import './result_ia_audio.component.style.scss';
import { FC } from 'react';
import ResultIAAudioComponentProps from './result_ia_audio.component.props';
import AccordionComponent from '../../../../../components/accordion/accordion.component';
import KeyWordLocalization from '../../../../../utils/KeyWordLocalization';
import DatesUtils from '../../../../../utils/dates_utils';
import useResultIAAudioComponentViewModel from './result_ia_audio.component.view_model';
import ButtonComponent from '../../../../../components/button/button.component';

const ResultIAAudioComponent: FC<ResultIAAudioComponentProps> = ({ result, reload, humanAgent }) => {
    const { expandedQuestions, i18n, scrollRef, openedTranscription, openedSummary, _questionIsExpanded, _toggleExpandedQuestions, _onSetOpenedTranscription, _onSetOpenedSummary, _onToggleCategory, handleOpenEditResponse } = useResultIAAudioComponentViewModel({ result, reload, humanAgent });
    return <div className="result_ia_audio_component" ref={scrollRef}>
        <div className="result">
            <div className="row">
                <div className="col-md-10 text_ellipsis">
                    <h5>{i18n(KeyWordLocalization.ResultIaAudioComponentTitle)}</h5>
                </div>
                {/* <div className="col-md-10">
                    <audio controls src={result.audioUrl} />
                </div> */}
                <div className={result.getMaxPoints() === 0 ? '' : 'col-md-2'}>
                    <div className="score d-flex flex-column align-items-end">
                        {
                            result.getMaxPoints() === 0 ? (
                                <div className="note alert alert-info">
                                <p><strong>{i18n(KeyWordLocalization.ResultIaAudioComponentNote)}</strong></p>
                                <p>{i18n(KeyWordLocalization.ResultIaAudioComponentNote1)}</p>
                                <p><em><strong>{i18n(KeyWordLocalization.ResultIaAudioComponentNote2)}</strong></em>.</p>
                                <p>{i18n(KeyWordLocalization.ResultIaAudioComponentNote3)}</p>
                              </div>
                              
                            ) : (
                                <div className="score d-flex flex-column align-items-end">
                                    <h5 className='mb-0'>{result.getTotalPointsResponse()}/{result.getMaxPoints()}</h5>
                                    <h6>{i18n(KeyWordLocalization.ResultIaAudioComponentScore)}</h6>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
            <AccordionComponent opened={openedSummary} onToggle={_onSetOpenedSummary} body={[
                {
                    header: <div className='px-2'>{i18n(KeyWordLocalization.ResultIaAudioComponentSummaryTitle)}</div>,
                    content: <div>
                        <p>{result.summary}</p>
                    </div>
                }
            ]} />

            <AccordionComponent opened={openedTranscription} onToggle={_onSetOpenedTranscription} body={[
                {
                    header: <div className='px-2'>{i18n(KeyWordLocalization.ResultIaAudioComponentTranscription)}</div>,
                    content: <div>
                        {result.transcription.conversation.map((chat, index) => <div className={`chat ${chat.senderIsClient && 'mine'}`} key={index}>
                            {chat.transcription}
                            <div className="text_light">{DatesUtils.ssToTime(chat.time)}</div>
                        </div>)}
                    </div>
                }
            ]} />
            <h6 className='mt-4'>
                {i18n(KeyWordLocalization.ResultIaAudioComponentResultsByCategory)}
            </h6>
            <AccordionComponent onToggle={_onToggleCategory} opened={expandedQuestions} body={result.categories.map((category) => {
                // const _percentage = category.getPercentageOfPoints();
                const _percentage = 70;
                return {
                    header: <div>
                        <div className="d-flex align-items-center">
                            {_percentage < 60 && <span className="material-symbols-outlined text-danger">sentiment_dissatisfied</span>}
                            {_percentage >= 60 && _percentage < 80 && <span className="material-symbols-outlined text_color_primary">sentiment_satisfied</span>}
                            {_percentage >= 80 && <span className="material-symbols-outlined text-success">sentiment_very_satisfied</span>}
                            <h6 className='ms-2'>{category.title} ({category.getTotalPointsResponse()}/{category.getMaxQuestionPoints()} {i18n(KeyWordLocalization.ResultIaAudioComponentPoints)})</h6>
                        </div>
                    </div>,
                    content: <div className="category_result">
                        {category.description.length > 0 && <div className="category_description">
                            {category.description}
                        </div>}
                        {category.questions.map((question, index) => <div key={index} className="">
                            <div className="question">
                                <h6>{question.title} ({question.points} {i18n(KeyWordLocalization.ResultIaAudioComponentPoints)})</h6>
                                {question.description.length > 100 && !_questionIsExpanded(index + "q") ? `${question.description.substring(0, 100)}...` : question.description}
                                {question.description.length > 100 && <span className='more_text' onClick={() => _toggleExpandedQuestions(index + "q")}>{_questionIsExpanded(index + "q") ? "Hide" : "Show"} {i18n(KeyWordLocalization.ResultIaAudioComponentMore)}</span>}
                            </div>
                            <div className='response'>
                                <div className="d-flex align-items-center mb-2">
                                    <div className="flex-grow-1">
                                        <strong>{question.response?.short} ({question.response?.points} {i18n(KeyWordLocalization.ResultIaAudioComponentPoints)})</strong>
                                    </div>
                                    <ButtonComponent
                                        text={i18n(KeyWordLocalization.edit)}
                                        icon={<span className='material-symbols-outlined'>edit</span>}
                                        onClick={() => handleOpenEditResponse(question.response, question.points)}
                                        type='button'
                                        design='primaryOutline'
                                    />
                                </div>
                                <p>{question.response?.justification}</p>
                            </div>
                        </div>)}
                    </div>
                }
            })} />
        </div>
    </div>
}

export default ResultIAAudioComponent;